export default __webpack_public_path__ + "static/media/una-app.7aa19e15.png";